import { render, staticRenderFns } from "./email-verification.vue?vue&type=template&id=375279b9&scoped=true&"
import script from "./email-verification.vue?vue&type=script&lang=js&"
export * from "./email-verification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375279b9",
  null
  
)

export default component.exports